// extracted by mini-css-extract-plugin
export default {"loader":"Loading_loader__0peLX","spinner":"Loading_spinner__Y9jaO","rotate":"Loading_rotate__ZztiU","path":"Loading_path__SsDAX","dash":"Loading_dash__IsRgQ"};